import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';
const Ai: FC<SvgProps> = ({ size = 24, className, color = 'currentColor' }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {}
      <path
        d="M17.11 13.77c-4.97-1.12-5.74-1.89-6.87-6.87a0.79 0.79 0 0 0-1.52 0c-1.13 4.98-1.9 5.75-6.87 6.87a0.79 0.79 0 0 0 0 1.52c4.97 1.12 5.74 1.89 6.87 6.87a0.79 0.79 0 0 0 1.52 0c1.13-4.98 1.9-5.75 6.87-6.87a0.79 0.79 0 0 0 0-1.52Z"
        fill={color}
      />
      {}
      <path
        d="M21.61 5.99c-2.64-0.6-3.01-0.98-3.61-3.61a0.79 0.79 0 0 0-1.52 0c-0.6 2.64-0.97 3.01-3.61 3.61a0.79 0.79 0 0 0 0 1.52c2.64 0.6 3.01 0.98 3.61 3.61a0.79 0.79 0 0 0 1.52 0c0.6-2.64 0.97-3.01 3.61-3.61a0.79 0.79 0 0 0 0-1.52Z"
        fill={color}
      />
    </svg>
  );
};
export default Ai;
